<div class="row">
  <div class="col-12 p-0">
    @if (viewConfig.loading) {
    <app-spinner-fullscreen></app-spinner-fullscreen>
    } @else if (viewConfig.error) {
    <ngb-alert (closed)="viewConfig.setDefault()" type="danger">{{
      viewConfig.error
    }}</ngb-alert>
    }
    <div id="main" class="table-responsive-sm">
      <table class="table ind-table table-hover">
        <thead class="ind-table-thead">
          <tr>
            <th scope="col">Chatbot Name</th>
            <th scope="col" class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (bot of bots; track bot.seqNumber) {
          <tr>
            <th scope="row">{{ bot.name }}</th>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-link p-0"
                [attr.aria-label]="'View bot ' + bot.name"
                (click)="getDetails(bot.id)"
                (keydown.enter)="getDetails(bot.id)"
                (keydown.space)="getDetails(bot.id)"
              >
                <img
                  [addAaTags]="'View bot ' + bot.name"
                  src="/icons/bold/preview.svg"
                />
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
